const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://streamsrvbac.n-tools.info";

export default API_BASE_URL;